import { useState } from 'react';
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  CircularProgress,
  Link,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { registerUser } from '../api';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

export default function Register() {
  const [username, setUsername] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  const navigate = useNavigate();

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setSuccessMessage(null);
    try {
      const detail = await registerUser(username, email, password);
      setSuccessMessage(detail);
    } catch (e: unknown) {
      setError(e instanceof Error ? e.message : '注册失败');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Container
      maxWidth="sm"
      sx={{ flex: 1, display: 'flex', alignItems: 'center', py: { xs: 4, sm: 6 } }}
    >
      <Card sx={{ width: '100%' }}>
        <CardContent sx={{ p: { xs: 3, sm: 4 }, '&:last-child': { pb: { xs: 3, sm: 4 } } }}>
          <Stack spacing={0.75} sx={{ mb: 3 }}>
            <Typography variant="h5" color="secondary.dark">
              创建账户
            </Typography>
            <Typography variant="body2" color="text.secondary">
              注册后将发送激活邮件。激活完成即可登录并开始测试。
            </Typography>
          </Stack>

          <Box component="form" onSubmit={onSubmit}>
            <Stack spacing={2}>
              <TextField
                label="用户名"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                autoFocus
                autoComplete="username"
              />
              <TextField
                label="邮箱"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoComplete="email"
              />
              <TextField
                label="密码"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                autoComplete="new-password"
                helperText="建议使用 8 位以上密码，并包含字母与数字。"
              />
              <Button
                variant="contained"
                color="secondary"
                type="submit"
                disabled={busy}
                size="large"
                sx={{ mt: 0.5 }}
                startIcon={busy ? <CircularProgress size={18} color="inherit" /> : undefined}
              >
                {busy ? '正在提交…' : '注册'}
              </Button>
            </Stack>
          </Box>
          {successMessage && (
            <Alert severity="success" sx={{ mt: 2 }}>
              {successMessage}
              <Box sx={{ mt: 1, textAlign: 'right' }}>
                <Button variant="text" onClick={() => navigate('/login')}>
                  返回登录
                </Button>
              </Box>
            </Alert>
          )}
          {error && (
            <Alert severity="error" sx={{ mt: 2 }}>
              {error}
            </Alert>
          )}

          <Typography variant="body2" sx={{ mt: 2.5, color: 'text.secondary' }}>
            已有账户？{' '}
            <Link component={RouterLink} to="/login" underline="hover">
              返回登录
            </Link>
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
}
